/** Keep consumers (including an open editor) attached to a replaceable service. */
export function liveReference<T extends object>(
  initial: T,
): {
  value: T
  replace(next: T): void
} {
  let current = initial
  const value = new Proxy(initial, {
    get(_target, key) {
      const member: unknown = Reflect.get(current, key, current)
      return typeof member === 'function' ? member.bind(current) : member
    },
    set(_target, key, value) {
      return Reflect.set(current, key, value, current)
    },
  })
  return {
    value,
    replace: (next) => {
      current = next
    },
  }
}
